import { render } from "./app-upload-support-document.vue?vue&type=template&id=800d40a8"
import script from "./app-upload-support-document.vue?vue&type=script&lang=js"
export * from "./app-upload-support-document.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-upload-support-document.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "800d40a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('800d40a8', __exports__)) {
    console.log('reload')
    api.reload('800d40a8', __exports__)
  }
  
  module.hot.accept("./app-upload-support-document.vue?vue&type=template&id=800d40a8", () => {
    console.log('re-render')
    api.rerender('800d40a8', render)
  })

}


export default __exports__